import React, { useState } from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import CareerCompanyFeatures from "../component/CareerCompanyFeatures";
import CareerInfo from "../component/CareerInfo";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { APPLY_JOB } from "../api/constants";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

function CareerDetail() {
    const location = useLocation();
  
  const [error, setError] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone_no, setPhone] = useState('');
  const [resume_file, setFile] = useState('');
  const [job_title, setJobTitle] = useState('');
  const [tell_us_about_your_self, setBio] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check required fields
    if (!resume_file) {
      setError("Please select your resume");
      return;
    }
    setError("");
    var formData = new FormData();
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("email", email);
    formData.append("phone_no", phone_no);
    formData.append("job_title", job_title);
    formData.append("tell_us_about_your_self", tell_us_about_your_self);
    formData.append("resume_file", resume_file);
    formData.append('job_id', location?.state.id)
    fetch(APPLY_JOB, {
      method: "POST",
      headers: {
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status) {
          //clear
          setEmail('');
          setFirstName('');
          setLastName('');
          setPhone('')
          setFile('')
          setJobTitle('')
          setBio('')

          Swal.fire({
            icon: 'success',
            title: 'Account created successfully',
            text: data.message
          });
        } else {
          setError(data.errors);
        }
      })
      .catch((error) => {
        console.error("Error creating account:", error);
        setError("Error creating account");
      });
  };
  return (
    <>
      <div className="main career-page">
        <Header />
        <CommonBanner title="Career" />
        <CareerInfo />
        <section className="career-cta-section common-padding" id="CareerForm">
          <Container>
            <Row>
              <Col md={12}>
                <div className="job-info">
                  <p className="section-title">Apply for this job</p>
                  <h2>Interested in a career with <span>Real Estate</span>?</h2>
                  <p>Please provide your information, and an HR will contact you.</p>
                </div>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group">
                        <Form.Label>FirstName <span>*</span></Form.Label>
                        <input className="form-control" required value={first_name} type="text" placeholder="First Name" name="first_name" onChange={(e) => setFirstName(e.target.value)} />

                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group">
                        <Form.Label>Lastname <span>*</span></Form.Label>
                        <input className="form-control" value={last_name} required type="text" placeholder="Last Name" name="last_name" onChange={(e) => setLastName(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group" controlId="formBasicEmail">
                        <Form.Label>Email Address <span>*</span></Form.Label>
                        <input className="form-control" value={email} required type="email" placeholder="Email Address" name="email" onChange={(e) => setEmail(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group">
                        <Form.Label>Phone Number <span>*</span></Form.Label>
                        <input className="form-control" value={phone_no} required type="tel" placeholder="Phone Number" name="phone_no" onChange={(e) => setPhone(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group">
                        <Form.Label>Job Title <span>*</span></Form.Label>
                        <input className="form-control" value={job_title} required type="text" placeholder="Job Title" name="job_title" onChange={(e) => setJobTitle(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-4 form-group">
                        <Form.Label>Upload File</Form.Label>
                        <div className="file-control">
                          <input className="form-control" name="resume_file" type="file" id="ChooseFile" placeholder="No file chosen*" onChange={(e) => setFile(e.target.files[0])}></input>
                          <div className='d-flex align-items-center'><Form.Label htmlFor="ChooseFile">Choose File</Form.Label> <span>{resume_file.name}</span></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-4 form-group w-full">
                        <Form.Label>Write Bio <span>*</span></Form.Label>
                        <textarea className="form-control" value={tell_us_about_your_self} required name="tell_us_about_your_self" rows={5} placeholder='Tell us about your self' onChange={(e) => setBio(e.target.value)}></textarea>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Button className="custom-bttn ani-1" type="submit">Submit</Button>
                    </Col>
                    <p className="text-danger text-center">{error}</p>

                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </section>
        <CareerCompanyFeatures />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default CareerDetail;
